<template>

  <MultiSelect
    v-if="meta?.mode == 'edit' || page_type === 'full-view'"
    v-model="model"
    :options="filteredItems"
    :optionLabel="optionLabel"
    :optionValue="optionValue"
    optionGroupLabel="label"
    optionGroupChildren="items"
    display="chip"
    :placeholder="placeholder"
    :maxSelectedLabels="maxSelectedLabels"
    class="w-full"
    filter
  >
    <template #optiongroup="slotProps">
      <div class="flex align-items-center country-item">
        <Icon
          type="favicon"
          icon="Notebook"
          class="Icon mr-2"
          style="width: 16px"
        />
        <div>{{ slotProps.option.label }}</div>
      </div>
    </template>
    <template #option="slotProps">
      <div class="flex align-items-center">
        <Icon
          type="favicon"
          icon="User"
          class="Icon mr-2"
          style="width: 16px"
        />
        <div>{{ slotProps.option.display_name }}</div>
      </div>
    </template>
    <template #footer>
      <div class="py-2 px-3">
        <b>{{ model ? model.length : 0 }}</b> item{{
          (model ? model.length : 0) > 1 ? "s" : ""
        }}
        selected.
      </div>
    </template>
  </MultiSelect>
  <div class="font-medium" v-else>
    {{ simplifiedValue }}
  </div>
</template>

<script>
import { useField } from "vee-validate";

export default {
  inheritAttrs: false,
  inject: ["meta"],
  props: {
    modelValue: { type: [Array, Boolean] },
    page_type: { String },
    loader: { type: Object },
    name: { type: String },
    placeholder: { type: String },
    optionLabel: { type: String, default: "display_name" },
    optionValue: { type: String, default: "" },
    maxSelectedLabels: { type: Number, default: 4 },
  },
  data() {
    const {
      value: inputValue,
      errorMessage,
      handleChange,
      meta: fieldMeta,
      resetField,
    } = useField(this.name, undefined, {
      initialValue: String(this.model || ""),
    });
    let data = {
      selectedItems: null,
      filteredItems: null,
    };

    return data;
  },
  mounted() {
    this.fetchAll("");
  },
  methods: {
    autocompleteChange(event) {},
    fetchAll(q) {
      return this.loader(q).then((res) => {
        this.filteredItems = res;
      });
    },
  },
  computed: {
    simplifiedValue() {
      let values = [];
      if (this.filteredItems) {
        let finderKey = this.optionValue || "id";
        for (var item of this.filteredItems) {
          if (Array.isArray(item?.items)) {
            for (var subItem of item.items) {
              let find = this.model.find(
                (value) => subItem[finderKey] == value
              );
              if (find) {
                values.push(subItem[this.optionLabel]);
              }
            }
          }
        }
        return values.join(", ");
      }
      return "";
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
